import { render, staticRenderFns } from "./deleteAttendanceClassesStaff.vue?vue&type=template&id=39d4dd14"
import script from "./deleteAttendanceClassesStaff.vue?vue&type=script&lang=js"
export * from "./deleteAttendanceClassesStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports